import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RoutingGroup } from '@app/core/interfaces/c5/routing-group';
import { ReactiveComponent } from '@app/shared/components/reactive-component';
import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';
import { ngValueAccessor } from '@app/utils/ng-value-accessor';
import { isBlank } from '@app/utils/string';
import { NgSelectComponent } from '@ng-select/ng-select';

const EMPTY_VALUE: 'empty' = 'empty';

@Component({
  selector: 'portal-routing-groups-select',
  templateUrl: './routing-groups-select.component.html',
  styles: [],
  providers: [ngValueAccessor(RoutingGroupsSelectComponent)],
  standalone: false,
})
export class RoutingGroupsSelectComponent
  extends ReactiveComponent
  implements OnChanges, OnInit, AfterViewInit
{
  @Input()
  public canEdit: boolean = true;

  @Input()
  public formControlName!: string;

  @Input()
  public routingGroups: RoutingGroup[];

  @Input()
  public emptyLabel: string = 'general.notSet';

  @Input()
  public isDisabled: boolean;

  @Output()
  public routingGroupChanged = new EventEmitter<RoutingGroup | null>();

  public typeahead: TypeaheadEntry<number>[] = [];

  public value: number;

  public routingGroup: RoutingGroup;

  @ViewChild('routingProfileSelectBox', { read: NgSelectComponent })
  routingProfileSelectBox: NgSelectComponent;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('routingGroups' in changes && changes.routingGroups.firstChange === false) {
      this.typeahead = this.calculateTypeahead(changes.routingGroups.currentValue);
    }
    if ('isDisabled' in changes) {
      this.setDisabledState(changes.isDisabled.currentValue);
    }
  }

  ngOnInit() {
    this.typeahead = this.calculateTypeahead(this.routingGroups);
  }

  ngAfterViewInit() {
    if (this.isDisabled != null) {
      // setTimeout(() => this.routingProfileSelectBox.setDisabledState(this.isDisabled), 0);
    }
  }

  public updateValue(value: number) {
    this.value = value;

    this.emitValue();
  }

  public writeValue(obj?: number): void {
    this.value = obj;
    if (this.value != null && this.routingGroups != null) {
      this.routingGroup = this.routingGroups.find((routingGroup) => routingGroup.id === this.value);
    }
  }

  private emitValue(): void {
    let routingGroup = null;
    let value = this.value;

    if (this.value != null) {
      routingGroup = this.routingGroups.find((routingGroup) => routingGroup.id === value);
    }

    this.routingGroup = routingGroup;
    this.onChange(value);
    this.routingGroupChanged.emit(routingGroup);
  }

  private calculateTypeahead(routingGroups: RoutingGroup[]): TypeaheadEntry<number>[] {
    const routingGroupTypeahead: TypeaheadEntry<number>[] = routingGroups.map((routingGroup) => {
      const label = isBlank(routingGroup.description)
        ? routingGroup.name
        : `${routingGroup.name} ${routingGroup.description}`;

      return {
        group: undefined,
        key: label,
        label: label,
        value: routingGroup.id,
        meta: {
          name: routingGroup.name,
          description: routingGroup.description,
        },
      };
    });

    return routingGroupTypeahead;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.routingProfileSelectBox != null) {
      this.routingProfileSelectBox.setDisabledState(this.disabled);
    }
  }
}
